import { FC, useState } from 'react'
import {
  MainPage,
  PageTitle,
  DispatchPrintModal,
  DispatchCreationFlow,
} from '../../components'

/**
 * Ruta `/Dispatch/create` — flujo manual de creación de manifiesto.
 *
 * El cuerpo vive en `DispatchCreationFlow` porque el detalle de una carga masiva
 * monta ese mismo flujo dentro de un modal, con las guías de la carga
 * preseleccionadas. Sin props, el componente se comporta exactamente como antes.
 *
 * El modal de impresión lo renderiza el HOST, no el flujo: `DispatchPrintModal`
 * escribe en `document.querySelector('iframe')`, así que no puede convivir con
 * otro modal con iframe abierto al mismo tiempo.
 */
const CreateDispatch: FC = () => {
  const [openPrintModal, setOpenPrintModal] = useState(false)
  const [manifestCode, setManifestCode] = useState('')

  return (
    <MainPage>
      <div className="flex justify-between items-center w-full mb-6">
        <PageTitle title="Creación de manifiesto de despacho" />
      </div>

      <DispatchCreationFlow
        onRequestPrint={(code) => {
          // El código va ANTES de abrir: el efecto de DispatchPrintModal tiene
          // deps [typeUrl, open] y no reacciona a un cambio posterior de
          // numberDispatch.
          setManifestCode(code)
          setOpenPrintModal(true)
        }}
      />

      <DispatchPrintModal
        open={openPrintModal}
        numberDispatch={manifestCode}
        setOpen={setOpenPrintModal}
      />
    </MainPage>
  )
}

export default CreateDispatch
